import * as React from 'react'
import { Route, Switch } from 'react-router'
import { Redirect } from 'react-router-dom'
import NotFound from './NotFound'
import Views from '../views/Views'
import Login from '../login/Login'
import View from '../view/View'

const RedirectComponent = () => (
  <Redirect to='/views/new'/>
)

const Routes = () => (
  <Switch>
    <Route path="/view/:id" exact={false} component={View} />
    <Route path="/views" exact={false} component={Views} />
    <Route path="/login" exact={false} component={Login} />
    <Route path="/" exact={true} component={RedirectComponent} />
    <Route component={NotFound} />
  </Switch>
)

export default Routes



// WEBPACK FOOTER //
// ./src/core/Routes.tsx